import type { FaireProductEntity } from "../../entity_types/product";

export const p_5rz585m4ww: FaireProductEntity = {
  token: "p_5rz585m4ww",
  type: "product",
  name: "Bite Me Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/233d2b5cebe30fae49e1330d6d554a5034224649dcce31f8ab1e7f81eb013254.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/430b19d3319e1df5dd563257847f96209640302b32c65334f0116804f4bcc695.jpeg",
    "https://cdn.faire.com/fastly/9ded97aea8d85c6101d590e52066a230fced40ac37ea89685b1fef8ae45d2780.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/1142a3fcc763ca704f2540398af9c74ec5fe8145c017093318ac48f3a57641f6.jpeg",
    "https://cdn.faire.com/fastly/7742f7cfdce812d8e9613b7ea56cb88276d0c1440e64da7bd51fce56cc039fa0.jpeg"
  ],
  priceDollars: 3.38,
  description: "Socks for the folks that DGAF about being likable (which—by the way—is inherently irresistible). 🤤\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:59.849Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
